import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RegularWhatsapp } from 'lineicons-react';
import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip, Stack } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const MarketPlaceContact = ({ phoneNumber, emailAddress }) => {
  const [showActions, setShowActions] = useState(false);
  const { merchant = {} } = useSelector((state) => state.inventory)

  const handleWhatsAppClick = () => {
    const message = 'Hello! I have a question about your store.';
    const mobileNumber = phoneNumber.startsWith('234') 
      ? phoneNumber
      : phoneNumber.startsWith('+234')
      ? phoneNumber.slice(1)
      : phoneNumber.startsWith('0')
      ? '234' + phoneNumber.slice(1)
      : phoneNumber;
    window.open(`https://wa.me/${mobileNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleEmailClick = () => {
    const subject = 'Inquiry about your store';
    const body = 'Hello,\n\nI would like to know more about...';
    window.open(`mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '10px'
    }}>
      {showActions && (
        <Stack gap={2}>
          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="whatsapp-tooltip">Chat on WhatsApp</Tooltip>}
          >
            <Button 
              className="bg-success text-white btn-plain" 
              onClick={handleWhatsAppClick}
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                padding: 0,
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              }}
            >
              <RegularWhatsapp fontSize={20}/>
            </Button>
          </OverlayTrigger>
          
          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="email-tooltip">Send Email</Tooltip>}
          >
            <Button 
              variant="secondary" 
              onClick={handleEmailClick}
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                padding: 0,
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
              }}
            >
              <FontAwesomeIcon icon={"envelope"} style={{fontSize: "20px"}} />
            </Button>
          </OverlayTrigger>
        </Stack>
      )}

      <Button
        variant="primary"
        onClick={() => setShowActions(!showActions)}
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          padding: 0,
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
        }}
      >
        <FontAwesomeIcon icon={"message"} style={{fontSize: "24px"}} />
      </Button>
    </div>
  );
};

export default MarketPlaceContact;